"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const CheckCircleRounded_1 = require("@mui/icons-material/CheckCircleRounded");
const InfoRounded_1 = require("@mui/icons-material/InfoRounded");
const merge_1 = require("merge");
const Divider_1 = require("../Divider");
const Typography_1 = require("../Typography");
const ProfileRow_styles_1 = require("./ProfileRow.styles");
const ProfileRow = ({ icon, title, value, status, onClick, divider, sx }) => {
    const { conatiner, data, statusBox } = (0, ProfileRow_styles_1.default)(status);
    const getIcon = () => {
        if (status === 'verified') {
            return (0, jsx_runtime_1.jsx)(CheckCircleRounded_1.default, {});
        }
        if (status === 'notVerified') {
            return (0, jsx_runtime_1.jsx)(InfoRounded_1.default, {});
        }
        return null;
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { onClick: onClick, sx: (0, merge_1.merge)(conatiner, sx), children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: data, children: [(0, jsx_runtime_1.jsx)("div", { children: icon }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(Typography_1.default, { typo: value ? 'caption_overline' : 'body_md', children: [" ", title] }), (0, jsx_runtime_1.jsx)(Typography_1.default, { typo: "body_md", children: value })] })] }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: statusBox, children: getIcon() })] }), divider && (0, jsx_runtime_1.jsx)(Divider_1.default, { type: "fullWidth" })] }));
};
exports.default = ProfileRow;
